import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { CtaAction } from '@sc/data-access-models';
import { map, take, tap } from 'rxjs';
import { AuthService } from '../services';

export const HoldGuard: CanActivateFn = () => {
  const authService = inject(AuthService);

  return authService.isAuthenticated$().pipe(
    take(1),
    tap((isAuth) => {
      if (!isAuth) {
        authService.setHoldAction(
          `${window.location.pathname}${window.location.search}` as CtaAction
        );
      }
    }),
    map(() => true)
  );
};
